// extracted by mini-css-extract-plugin
export default {"wrapper":"Ft","subscription":"Gt","select_item":"Ht","is_selected":"It","otb":"Jt","radio":"Kt","first_row":"Lt","prices":"Mt","italic":"Nt","info_wrapper":"Ot","first_month":"Pt","separator":"Qt","checkmark":"Rt","bullets":"St","bullet":"Tt","checkmarkText":"Ut","button":"Vt","discountBadge":"Wt"};
    if(module.hot) {
      // 1713211512757
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  